<template>
  <div class="page">
    <div>金安心</div>
    <br>
    <div
      @click="$router.push({
        path: `/membership/heart`})"
    >
      MemberShip
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/appointment/making/heart`})"
    >
      Appointment
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/appointment/query/heart`})"
    >
      Appointment query
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/feedback/heart`})"
    >
      feedback
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/chat/heart`})"
    >
      chat
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/visitor-registration/heart`})"
    >
      visitor-registration
    </div>
    <br>
    <div>金禾美</div>
    <br>
    <div
      @click="$router.push({
        path: `/membership/beauty`})"
    >
      MemberShip
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/appointment/making/beauty`})"
    >
      Appointment
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/appointment/query/beauty`})"
    >
      Appointment query
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/feedback/beauty`})"
    >
      feedback
    </div>
    <br>
    <div
      @click="$router.push({
        path: `/chat/beauty`})"
    >
      chat
    </div>
    <br>
  </div>
</template>
